/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   7/29/20 3:53 PM
 */

import React from "react";
import {IconButton, Stack, Tooltip, useTheme} from "@mui/material";
import {Link} from "react-router-dom";
import UserMenu from "./UserMenu";
import UpdatesMenu from "./UpdatesMenu";
import ThemeToggle from "./ThemeToggle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSlack } from "@fortawesome/free-brands-svg-icons";
import { faChartBar } from "@fortawesome/free-solid-svg-icons";
import TodayIcon from '@mui/icons-material/Today';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import AppsMenu from "./AppsMenu";
import HelpMenu from "./HelpMenu";
import NotificationCenter from "./NotificationCenter";

export default function GlobalNav() {

	const theme = useTheme();
	const backgroundColor = "#172B4D";

	return (
		<Stack
			sx={{
				backgroundColor,
				width: theme.spacing(8),
				height: "100%",
				position: "fixed",
				p: 2
			}}
			spacing={2}
			alignItems={"center"}
			justifyContent={"space-between"}
		>
			<Stack spacing={1}>
				<Stack sx={{ mb: 8 }}>
					<Link to={"/"}>
						<img src={"/img/ua.png"} width={40} alt={"Logo"}/>
					</Link>
				</Stack>
				<Tooltip title={"Calendar"} placement={"right"}>
					<IconButton sx={{ color: "#fff" }} component={Link} to={"/"}>
						<TodayIcon sx={{ fontSize: 26 }} />
					</IconButton>
				</Tooltip>
				<Tooltip title={"Manage Calendars"} placement={"right"}>
					<IconButton sx={{ color: "#fff" }} component={Link} to={"/manage"}>
						<ManageSearchIcon sx={{ fontSize: 26 }} />
					</IconButton>
				</Tooltip>
				<Tooltip title={"Notifications"} placement={"right"}>
					<IconButton sx={{ color: "#fff" }} component={Link} to={"/notifications"}>
						<FontAwesomeIcon fixedWidth icon={faSlack} />
					</IconButton>
				</Tooltip>
				<Tooltip title={"Reports"} placement={"right"}>
					<IconButton sx={{ color: "#fff" }} component={Link} to={"/reports"}>
						<FontAwesomeIcon icon={faChartBar} />
					</IconButton>
				</Tooltip>
			</Stack>
			<Stack alignItems={"center"} spacing={.5}>
				<ThemeToggle />
				<NotificationCenter />
				<UpdatesMenu />
				<AppsMenu />
				<HelpMenu />
				<UserMenu />
			</Stack>
		</Stack>
	);

}